// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Row-module--cls1--3OQpL","cls2":"styles-Row-module--cls2--3mmkE styles-Row-module--cls1--3OQpL"};